import {VStack} from 'platform/foundation';

import {chatPublicApi} from '../../api/chatPublicApi';
import {MessageForm} from './components/MessageForm';
import {Timeline} from './components/Timeline';
import {useChatSubscribe} from './hooks/useChatSubscribe';

interface ChatProps {
  conversationId: string;
  sellerName: string;
}

export function Chat(props: ChatProps) {
  const conversation = chatPublicApi.useGetPublicConversationQuery({
    conversationId: props.conversationId,
  });

  const userId = conversation.data?.users.find((item) => item.type === 'PUBLIC')?.id || '';

  const {isTyping} = useChatSubscribe({conversationId: props.conversationId, userId});

  return (
    <VStack spacing={5}>
      <Timeline conversationId={props.conversationId} />
      <MessageForm
        conversationId={props.conversationId}
        isTyping={isTyping}
        sellerName={props.sellerName}
        customerId={userId}
        tenantId={conversation.data?.tenantId || ''}
      />
    </VStack>
  );
}
